import api from '@/utils/api';

/**
 * Reset User Password
 * @param {string} token - the reset token
 * @param {object} resetData - The user data
 * @returns {Promise}
 */
const resetPasswordApi = (token, resetData) =>
  api.patch(`/auth/reset-password/${token}`, resetData);

export default resetPasswordApi;
